import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Bitcoin, ShieldCheck, WalletCards } from 'lucide-react';
import WalletSelector from './WalletSelector';
import useBuyNow from '../../../hooks/DataFetching/useBuyNow';
import { StatusMessage } from '../../ui/StatusMessage';

const BuyNowModal = ({ show, handleClose, userId, asset }) => {
  const {
    selectedWallet,
    setSelectedWallet,
    handleBuyNow,
    buying,
    purchaseError,
    purchaseSuccess,
  } = useBuyNow(userId, asset, handleClose);

  const handleWalletSelect = (walletAddress) => {
    setSelectedWallet(walletAddress);
  };

  const assetTitle = asset?.productName || asset?.assetName || 'Marketplace listing';
  const btcPrice = asset?.salePrice || '0.00000000';

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      contentClassName="marketplace-flow-modal"
    >
      <Modal.Header closeButton className="marketplace-flow-header">
        <Modal.Title>
          <span className="marketplace-flow-kicker"><Bitcoin className="h-4 w-4" /> BTC checkout</span>
          Buy with Bitcoin
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="marketplace-flow-body">
        <div className="marketplace-flow-grid">
          <section className="marketplace-flow-panel" aria-label="Purchase summary">
            <div className="marketplace-flow-panel-heading">
              <Bitcoin className="h-5 w-5" />
              <div>
                <span>Listing</span>
                <strong>{assetTitle}</strong>
              </div>
            </div>
            <dl className="marketplace-flow-facts">
              <div>
                <dt>BTC price</dt>
                <dd>{btcPrice} BTC</dd>
              </div>
              <div>
                <dt>Seller wallet</dt>
                <dd>{asset?.recipientWalletAddress || 'Provided by seller'}</dd>
              </div>
            </dl>
            <div className="marketplace-flow-note">
              <ShieldCheck className="h-5 w-5" />
              <span>Review the listing and your sending wallet before submitting. This creates a marketplace transaction request.</span>
            </div>
          </section>

          <section className="marketplace-flow-panel" aria-label="Wallet selection">
            <div className="marketplace-flow-panel-heading">
              <WalletCards className="h-5 w-5" />
              <div>
                <span>Payment source</span>
                <strong>Select a wallet</strong>
              </div>
            </div>
            <WalletSelector selectedWallet={selectedWallet} onSelect={handleWalletSelect} />
          </section>
        </div>

        {purchaseError && (
          <StatusMessage
            tone="error"
            title="Could not complete purchase"
            message={purchaseError}
          />
        )}
        {purchaseSuccess && (
          <StatusMessage
            tone="info"
            title="Purchase submitted"
            message="Your purchase was submitted successfully."
          />
        )}
      </Modal.Body>
      <Modal.Footer className="marketplace-flow-footer">
        <Button variant="outline-light" onClick={handleClose} className="marketplace-secondary-action">
          Cancel
        </Button>
        <Button variant="success" onClick={handleBuyNow} disabled={!selectedWallet || buying} className="marketplace-primary-action">
          {buying ? 'Submitting purchase...' : 'Submit BTC purchase'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BuyNowModal;
